/* eslint-disable */
// @ts-nocheck

import { ArrowRightIcon } from '@heroicons/react/24/solid'

export interface TabsAttr {
  icon?: React.ReactNode
  name: string
  href: string
  current: boolean
  disabled?: boolean
}

interface TabNavProp {
  className?: string
  tabs: TabsAttr[]
  action: (currentHref: string) => void
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export default function SideNav({ tabs, action, className }: TabNavProp) {
  return (
    <div className={`${className && className}`}>
      <div className="sm:hidden">
        <label className="sr-only" htmlFor="tabs">
          Selecccione
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          className="block w-full rounded-md border-gray-300 focus:border-slate-500 focus:ring-slate-500"
          id="tabs"
          name="tabs"
          onChange={(e) => action(e.target.value)}
          value={tabs?.find((tab) => tab.current)?.href}
        >
          {tabs
            .filter((elem) => !elem.disabled)
            .map((tab) => (
              <option key={tab.name} value={tab.href}>
                {tab.name}
              </option>
            ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="pt-1">
          <nav className="flex flex-col gap-1">
            {tabs
              .filter((elem) => !elem.disabled)
              .map((tab, idx) => (
                <div className="inline-flex w-full flex-shrink-0" key={idx}>
                  <div
                    className={`inline-flex w-full flex-shrink-0 gap-2 border-y ${
                      tab.current
                        ? 'scale-105 border-slate-600 shadow-md'
                        : tab.disabled
                          ? 'border-slate-300'
                          : 'border-slate-400'
                    } rounded-r-md transition-all delay-75 ease-in-out`}
                    key={tab.name}
                    onClick={() => {
                      if (!tab.disabled) action(tab.href)
                    }}
                  >
                    <span
                      className={`w-0.5 ${
                        tab.current ? 'bg-slate-700' : ''
                      } pr-2`}
                    ></span>
                    <p
                      aria-current={tab.current ? 'page' : undefined}
                      className={classNames(
                        tab.current
                          ? 'text-slate-700'
                          : tab.disabled
                            ? 'text-slate-300'
                            : 'text-slate-500 hover:text-slate-600',
                        'flex flex-grow cursor-pointer items-center gap-2 truncate py-2 text-sm font-medium'
                      )}
                    >
                      {tab?.icon && tab.icon}
                      {tab.name}
                    </p>
                  </div>
                </div>
              ))}
          </nav>
        </div>
      </div>
    </div>
  )
}
